import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectPodPayments: "selectPodPayments [Action]",
  selectPodPaymentsLoading: "selectPodPaymentsLoading [Action]",
  selectPodPaymentsAsync: "selectPodPaymentsAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const selectPodPaymentsReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectPodPayments:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectPodPaymentsLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectPodPaymentsLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "payment",
    method_type: "select_pod_payments",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectPodPayments,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectPodPaymentsLoading,
      payload: false,
    });
  }
}

export function* selectPodPayments() {
  yield takeLatest(actionTypes.selectPodPaymentsAsync, handleWorker);
}
